import { render, staticRenderFns } from "./cmpcadastrorapidocliente.vue?vue&type=template&id=3e521838&"
import script from "./cmpcadastrorapidocliente.vue?vue&type=script&lang=js&"
export * from "./cmpcadastrorapidocliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports